module.exports = __webpack_public_path__ + "../resources/images/searching-3d6501048ae0287be8cc625ce54e2b3d.svg";